<template>
    <by-effect>
        <template v-slot:header>
            <img src="../../../assets/images/doctor/by-effects/kidney.png" alt="effect image">
        </template>

        <template v-slot:content>
            <p>Під час лікування у пацієнта виникла <strong>тяжка ниркова недостатність</strong></p>
        </template>
    </by-effect>
</template>

<script>
import ByEffect from './ByEffect';

export default {
    components : {
        'by-effect' : ByEffect
    }
}
</script>